import { render, staticRenderFns } from "./NewGroupButton.vue?vue&type=template&id=75c4dbbe"
import script from "./NewGroupButton.vue?vue&type=script&lang=js"
export * from "./NewGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports